
export const GA_TRACKING_ID = process.env.REACT_APP_GOOGLE_ANALYTICS_ID


export const initGA = () => {
    if (typeof window !== 'undefined' && GA_TRACKING_ID) {
        console.log(GA_TRACKING_ID, "GA_TRACKING_ID")
        window.dataLayer = window.dataLayer || [];
        function gtag() { window.dataLayer.push(arguments); }
        gtag('js', new Date());

        gtag('config', GA_TRACKING_ID, {
            debug_mode: true,
            page_location: window.location.href,
            // Cross-domain configuration
            linker: {
                domains: ['localhost'] // This matches your GA settings
            }
        });

        const script = document.createElement('script');
        script.src = `https://www.googletagmanager.com/gtag/js?id=${GA_TRACKING_ID}`;
        script.async = true;
        document.head.appendChild(script);

        console.log('GA4 initialized for localhost with cross-domain tracking');
    }
};